import { GetServerSideProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { FC } from "react";
import Experience from "~/components/HomeSections/Experience";
import Hero from "~/components/ResourceSections/Hero";
import ResourceListSection from "~/components/ResourceSections/ResourceListSection";
import { Category, ResourceApi, ResourceTypes } from "~/services/resource";
import Trans from "~/types/translationKeys";

interface ResourcesProps {
  categories: Category[];
}

const Resources: FC<ResourcesProps> = ({ categories }) => {
  const { t } = useTranslation();

  return (
    <main className="bg-white">
      <Hero />

      <div className="flex flex-col mt-[72px] gap-y-24 mb-[100px]">
        <ResourceListSection
          id="product-videos"
          title={t(Trans.product_videos)}
          type={ResourceTypes.PRODUCT_VIDEOS}
        />
        <ResourceListSection
          id="blogs"
          title={t(Trans.blogs)}
          type={ResourceTypes.BLOGS}
          categories={categories}
          className="!gap-y-4"
          containerClassName="!gap-y-4"
        />
        <ResourceListSection
          variant="secondary"
          id="case-study"
          title={t(Trans.case_studies)}
          type={ResourceTypes.CASE_STUDY}
        />
      </div>

      <Experience />
    </main>
  );
};
export default Resources;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const categories = await ResourceApi.getCategories();

  return {
    props: {
      categories,
      ...(await serverSideTranslations(context.locale || "en", ["common"])),
    },
  };
};
